import React, { Component } from "react";

export default class MissingRight extends Component {
  render() {
    return <div>Nincs joga a művelethez!</div>;
  }
}
